module.exports = __webpack_public_path__ + "static/img/service-h5-3.5c461a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/service-h5-3.png
// module id = pNQh
// module chunks = 34